import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { A11yModule } from '@angular/cdk/a11y';
import { LcsAdvancedMultiSelectModule } from '@lcs/shared/advanced-multi-select';
import { LcsMultiSelectModule } from '@lcs/shared/multi-select';
import { CallRetentionPolicyPipeModule } from 'src/app/pipes/call-retention-policy-pipe/call-retention-policy-pipe.module';
import { FormatPhoneNumberorExtensionPipeModule } from 'src/app/pipes/format-phone-number-or-extension/format-phone-number-pipe.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { AccountSelectInputDirective } from './account/component/account-select-input.directive';
import { AccountSelectComponent } from './account/component/account-select.component';
import { BasestationChipInputComponent } from './base-station-multichip-select/chip-input/basestation-chip-input.component';
import { BaseStationGroupSelectComponent } from './base-station-multichip-select/component/basestation-select.component';
import { CallRetentionPolicySelectInputDirective } from './call-retention-policy/component/call-retention-policy-select-input.directive';
import { CallRetentionPolicySelectComponent } from './call-retention-policy/component/call-retention-policy-select.component';
import { DayOfWeekSelectInputDirective } from './day-of-week/component/day-of-week-select-input.directive';
import { DayOfWeekSelectComponent } from './day-of-week/component/day-of-week-select.component';
import { DepartmentChipGridComponent } from './department/chip-grid/department-chip-grid.component';
import { DepartmentChipInputComponent } from './department/chip-input/department-chip-input.component';
import { DepartmentSelectInputDirective } from './department/component/department-select-input.directive';
import { DepartmentSelectComponent } from './department/component/department-select.component';
import { DeviceTypeSelectInputDirective } from './device-type/component/device-type-select-input.directive';
import { DeviceTypeSelectComponent } from './device-type/component/device-type-select.component';
import { ExtensionAndExtensionGroupChipInputComponent } from './extension-and-extension-group/chip-input/extension-and-group-chip-input.component';
import { ExtensionAndExtensionGroupSelectComponent } from './extension-and-extension-group/component/extension-and-group-select.component';
import { PhoneExtensionAndExternalNumbersChipInputComponent } from './extension-and-external-numbers/chip-input/extension-and-external-numbers-chip-input.component';
import { ExtensionAndExternalNumbersSelectComponent } from './extension-and-external-numbers/component/extension-and-external-numbers-select.component';
import { ExtensionGroupSelectInputDirective } from './extension-group/component/extension-group-select-input.directive';
import { ExtensionGroupSelectComponent } from './extension-group/component/extension-group-select.component';
import { ExtensionGroupMultiSelectTriggerDirective } from './extension-group/multi-select/extension-group-multi-select-trigger.directive';
import { ExtensionGroupMultiSelectDirective } from './extension-group/multi-select/extension-group-multi-select.directive';
import { ExtensionTypeSelectInputDirective } from './extension-type/component/extension-type-select-input.directive';
import { ExtensionTypeSelectComponent } from './extension-type/component/extension-type-select.component';
import { ExtensionChipGridComponent } from './extension/chip-grid/extension-chip-grid.component';
import { ExtensionChipInputComponent } from './extension/chip-input/extension-chip-input.component';
import { ExtensionSelectInputDirective } from './extension/component/extension-select-input.directive';
import { ExtensionSelectComponent } from './extension/component/extension-select.component';
import { ExtensionAdvancedMultiSelectComponent } from './extension/multi-select/extension-advanced-multi-select.component';
import { ExtensionChipMultiSelectTriggerDirective } from './extension/multi-select/extension-chip-multi-select-trigger.directive';
import { ExtensionMultiSelectTriggerDirective } from './extension/multi-select/extension-multi-select-trigger.directive';
import { ExtensionMultiSelectDirective } from './extension/multi-select/extension-multi-select.directive';
import { FaxFileTypeSelectInputDirective } from './fax-file-type/component/fax-file-type-select-input.directive';
import { FaxFileTypeSelectComponent } from './fax-file-type/component/fax-file-type-select.component';
import { FaxStatusSelectInputDirective } from './fax-status/component/fax-status-select-input.directive';
import { FaxStatusSelectComponent } from './fax-status/component/fax-status-select.component';
import { FaxTypeSelectInputDirective } from './fax-type/component/fax-type-select-input.directive';
import { FaxTypeSelectComponent } from './fax-type/component/fax-type-select.component';
import { LocationSelectInputDirective } from './location/component/location-select-input.directive';
import { LocationSelectComponent } from './location/component/location-select.component';
import { LogLevelSelectInputDirective } from './log-level/component/log-level-select-input.directive';
import { LogLevelSelectComponent } from './log-level/component/log-level-select.component';
import { NameDirectoryPreferenceSelectInputDirective } from './name-directory-preference/component/name-directory-preference-select-input.directive';
import { NameDirectoryPreferenceSelectComponent } from './name-directory-preference/component/name-directory-preference-select.component';
import { PhoneExtensionAndExtensionGroupChipInputComponent } from './phone-extension-and-extension-group/chip-input/extension-and-group-chip-input.component';
import { DeviceSelectComponent } from './phone/component/device-select-component';
import { DeviceSelectInputDirective } from './phone/component/device-select-input.directive';
import { DeviceChipGridComponent } from './phone/multi-select/chip-grid/device-chip-grid.component';
import { DeviceChipInputComponent } from './phone/multi-select/chip-input/device-chip-input.component';
import { PhoneNumberSelectInputDirective } from './phonenumber/component/phone-number-select-input.directive';
import { PhoneNumberSelectComponent } from './phonenumber/component/phone-number-select.component';
import { PhoneNumberChipMultiSelectTriggerDirective } from './phonenumber/multi-select/phone-number-chip-multi-select-trigger.directive';
import { PhoneNumberMultiSelectTriggerDirective } from './phonenumber/multi-select/phone-number-multi-select-trigger.directive';
import { PhoneNumberMultiSelectDirective } from './phonenumber/multi-select/phone-number-multi-select.directive';
import { PhoneSelectComponent } from './phones/component/phone-select-component';
import { PhoneSelectInputDirective } from './phones/component/phone-select-input.directive';
import { PromptTypeSelectInputDirective } from './prompt-type/component/prompt-type-select-input.directive';
import { PromptTypeSelectComponent } from './prompt-type/component/prompt-type-select.component';
import { PromptSelectInputDirective } from './prompt/component/prompt-select-input.directive';
import { PromptSelectComponent } from './prompt/component/prompt-select.component';
import { QueueManagementStrategySelectInputDirective } from './queue-management/component/queue-management-select-input.directive';
import { QueueManagementStrategySelectComponent } from './queue-management/component/queue-management-select.component';
import { RoleChipGridComponent } from './role/chip-grid/role-chip-grid.component';
import { RoleSelectInputDirective } from './role/component/role-select-input.directive';
import { RoleSelectComponent } from './role/component/role-select.component';
import { RoleAdvancedMultiSelectComponent } from './role/multi-select/role-advanced-multi-select.component';
import { RoleChipMultiSelectTriggerDirective } from './role/multi-select/role-chip-multi-select-trigger.directive';
import { RoleMultiSelectTriggerDirective } from './role/multi-select/role-multi-select-trigger.directive';
import { RoleMultiSelectDirective } from './role/multi-select/role-multi-select.directive';
import { ScheduleSelectInputDirective } from './schedule/component/schedule-select-input.directive';
import { ScheduleSelectComponent } from './schedule/component/schedule-select.component';
import { ScheduleAdvancedMultiSelectComponent } from './schedule/multi-select/schedule-advanced-multi-select.component';
import { ServerSelectInputDirective } from './server/component/server-select-input.directive';
import { ServerSelectComponent } from './server/component/server-select.component';
import { LcsSingleSelectModule } from './single-select/single-select.module';
import { StateSelectComponent } from './state-select/state-select.component';
import { SystemLogAreaSelectInputDirective } from './system-log-area/component/system-logs-area-select-input.directive';
import { SystemLogAreaSelectComponent } from './system-log-area/component/system-logs-area-select.component';
import { SystemLogTypeSelectInputDirective } from './system-log-type/component/system-logs-type-select-input.directive';
import { SystemLogTypeSelectComponent } from './system-log-type/component/system-logs-type-select.component';
import { SystemLogSeveritySelectInputDirective } from './system-logs-severity/component/system-logs-severity-select-input.directive';
import { SystemLogSeveritySelectComponent } from './system-logs-severity/component/system-logs-severity-select.component';
import { TimeZoneSelectInputDirective } from './timezone/component/time-zone-select-input.directive';
import { TimeZoneSelectComponent } from './timezone/component/time-zone-select.component';
import { UserChipGridComponent } from './user/chip-grid/user-chip-grid.component';
import { UserSelectInputDirective } from './user/component/user-select-input.directive';
import { UserSelectComponent } from './user/component/user-select.component';
import { UserChipMultiSelectTriggerDirective } from './user/multi-select/user-chip-multi-select-trigger.directive';
import { UserMultiSelectTriggerDirective } from './user/multi-select/user-multi-select-trigger.directive';
import { UserMultiSelectDirective } from './user/multi-select/user-multi-select.directive';

@NgModule({
   declarations: [
      AccountSelectComponent,
      AccountSelectInputDirective,
      DayOfWeekSelectComponent,
      DayOfWeekSelectInputDirective,
      DeviceSelectComponent,
      DeviceSelectInputDirective,
      ExtensionTypeSelectComponent,
      DeviceTypeSelectComponent,
      ExtensionTypeSelectInputDirective,
      DeviceTypeSelectInputDirective,
      TimeZoneSelectComponent,
      QueueManagementStrategySelectComponent,
      TimeZoneSelectInputDirective,
      QueueManagementStrategySelectInputDirective,
      PhoneNumberSelectComponent,
      PhoneNumberSelectInputDirective,
      ExtensionChipGridComponent,
      ExtensionSelectComponent,
      ExtensionSelectInputDirective,
      ExtensionMultiSelectDirective,
      ExtensionGroupSelectComponent,
      ExtensionGroupSelectInputDirective,
      ExtensionGroupMultiSelectDirective,
      ExtensionGroupMultiSelectTriggerDirective,
      ExtensionMultiSelectTriggerDirective,
      PhoneSelectComponent,
      PhoneSelectInputDirective,
      PhoneNumberMultiSelectDirective,
      PhoneNumberMultiSelectTriggerDirective,
      PhoneNumberChipMultiSelectTriggerDirective,
      ExtensionChipMultiSelectTriggerDirective,
      ExtensionChipInputComponent,
      DepartmentChipInputComponent,
      DepartmentChipGridComponent,
      DepartmentSelectComponent,
      DepartmentSelectInputDirective,
      DeviceChipInputComponent,
      DeviceChipGridComponent,
      ExtensionAndExtensionGroupChipInputComponent,
      BasestationChipInputComponent,
      PhoneExtensionAndExtensionGroupChipInputComponent,
      PhoneExtensionAndExternalNumbersChipInputComponent,
      ExtensionAndExternalNumbersSelectComponent,
      ExtensionAdvancedMultiSelectComponent,
      ExtensionAndExtensionGroupSelectComponent,
      BaseStationGroupSelectComponent,
      FaxStatusSelectComponent,
      FaxStatusSelectInputDirective,
      FaxTypeSelectInputDirective,
      FaxTypeSelectComponent,
      LocationSelectComponent,
      LocationSelectInputDirective,
      LogLevelSelectComponent,
      LogLevelSelectInputDirective,
      FaxFileTypeSelectInputDirective,
      FaxFileTypeSelectComponent,
      PromptTypeSelectComponent,
      PromptTypeSelectInputDirective,
      PromptSelectComponent,
      PromptSelectInputDirective,
      RoleSelectInputDirective,
      RoleSelectComponent,
      RoleMultiSelectDirective,
      RoleMultiSelectTriggerDirective,
      RoleChipMultiSelectTriggerDirective,
      RoleAdvancedMultiSelectComponent,
      RoleChipGridComponent,
      ScheduleAdvancedMultiSelectComponent,
      ScheduleSelectComponent,
      ScheduleSelectInputDirective,
      ServerSelectComponent,
      ServerSelectInputDirective,
      StateSelectComponent,
      SystemLogSeveritySelectComponent,
      SystemLogSeveritySelectInputDirective,
      SystemLogTypeSelectInputDirective,
      SystemLogTypeSelectComponent,
      SystemLogAreaSelectComponent,
      SystemLogAreaSelectInputDirective,
      CallRetentionPolicySelectComponent,
      CallRetentionPolicySelectInputDirective,
      NameDirectoryPreferenceSelectComponent,
      NameDirectoryPreferenceSelectInputDirective,
      UserChipGridComponent,
      UserSelectComponent,
      UserSelectInputDirective,
      UserMultiSelectDirective,
      UserMultiSelectTriggerDirective,
      UserChipMultiSelectTriggerDirective,
   ],
   exports: [
      AccountSelectComponent,
      DayOfWeekSelectComponent,
      DayOfWeekSelectInputDirective,
      DeviceSelectComponent,
      DeviceSelectInputDirective,
      DeviceChipInputComponent,
      DeviceChipGridComponent,
      LcsSingleSelectModule,
      FaxFileTypeSelectInputDirective,
      FaxFileTypeSelectComponent,
      FaxTypeSelectComponent,
      FaxTypeSelectInputDirective,
      FaxStatusSelectComponent,
      FaxStatusSelectInputDirective,
      AccountSelectInputDirective,
      ExtensionTypeSelectComponent,
      DeviceTypeSelectComponent,
      ExtensionTypeSelectInputDirective,
      DeviceTypeSelectInputDirective,
      TimeZoneSelectComponent,
      QueueManagementStrategySelectComponent,
      TimeZoneSelectInputDirective,
      QueueManagementStrategySelectInputDirective,
      ExtensionGroupSelectComponent,
      ExtensionGroupSelectInputDirective,
      PhoneSelectComponent,
      PhoneSelectInputDirective,
      PhoneNumberSelectComponent,
      PhoneNumberSelectInputDirective,
      DepartmentSelectComponent,
      DepartmentChipInputComponent,
      DepartmentChipGridComponent,
      DepartmentSelectInputDirective,
      ExtensionAdvancedMultiSelectComponent,
      ExtensionChipGridComponent,
      ExtensionSelectComponent,
      ExtensionChipInputComponent,
      ExtensionSelectInputDirective,
      ExtensionMultiSelectDirective,
      ExtensionGroupMultiSelectDirective,
      ExtensionGroupMultiSelectTriggerDirective,
      ExtensionAndExtensionGroupChipInputComponent,
      BasestationChipInputComponent,
      PhoneExtensionAndExtensionGroupChipInputComponent,
      PhoneExtensionAndExternalNumbersChipInputComponent,
      ExtensionAndExternalNumbersSelectComponent,
      ExtensionAndExtensionGroupSelectComponent,
      BaseStationGroupSelectComponent,
      PhoneNumberMultiSelectDirective,
      PhoneNumberMultiSelectTriggerDirective,
      PhoneNumberChipMultiSelectTriggerDirective,
      ExtensionMultiSelectTriggerDirective,
      ExtensionChipMultiSelectTriggerDirective,
      LocationSelectComponent,
      LocationSelectInputDirective,
      LogLevelSelectComponent,
      LogLevelSelectInputDirective,
      FaxFileTypeSelectInputDirective,
      FaxFileTypeSelectComponent,
      NameDirectoryPreferenceSelectComponent,
      NameDirectoryPreferenceSelectInputDirective,
      PromptTypeSelectComponent,
      PromptTypeSelectInputDirective,
      PromptSelectComponent,
      PromptSelectInputDirective,
      RoleSelectInputDirective,
      RoleSelectComponent,
      RoleMultiSelectDirective,
      RoleMultiSelectTriggerDirective,
      RoleChipMultiSelectTriggerDirective,
      RoleAdvancedMultiSelectComponent,
      RoleChipGridComponent,
      ScheduleAdvancedMultiSelectComponent,
      ScheduleSelectComponent,
      ScheduleSelectInputDirective,
      ServerSelectComponent,
      ServerSelectInputDirective,
      SystemLogSeveritySelectComponent,
      SystemLogSeveritySelectInputDirective,
      SystemLogTypeSelectInputDirective,
      SystemLogTypeSelectComponent,
      SystemLogAreaSelectComponent,
      SystemLogAreaSelectInputDirective,
      MatChipsModule,
      StateSelectComponent,
      CallRetentionPolicySelectComponent,
      CallRetentionPolicySelectInputDirective,
      UserChipGridComponent,
      UserSelectComponent,
      UserSelectInputDirective,
      UserMultiSelectDirective,
      UserMultiSelectTriggerDirective,
      UserChipMultiSelectTriggerDirective,
   ],
   imports: [
      LcsSingleSelectModule,
      CommonModule,
      LocationModule,
      AddSpacesPipeModule,
      MatChipsModule,
      MatIconModule,
      MatFormFieldModule,
      MatTooltipModule,
      FormatPhoneNumbersPipeModule,
      FormatPhoneNumberorExtensionPipeModule,
      LcsAdvancedMultiSelectModule,
      LcsMultiSelectModule,
      ReactiveFormsModule,
      CallRetentionPolicyPipeModule,
      A11yModule
   ],
})
export class EntitySelectModule {}
